import { call, put } from 'redux-saga/effects';
import {
  getAnonymous,
  postAnonymous,
} from '../services/api';
import {
  searchPetTagAttempt,
  searchPetTagFailed,
  searchPetTagFound,
  sendMessageFailed,
  sendMessageSucceed,
} from '../actions';

export function* doSearchPetTag(dispatch, action) {
  const { petTag } = action.payload;

  yield put(searchPetTagAttempt());

  const response = yield call(
    getAnonymous,
    dispatch,
    `customer/pets/tags/${petTag}`,
  );

  const petTagResponse = response.success ? {
    Data: {
      BreedName: response.breedName,
      City: response.city,
      ImageUrl: response.imageUrl,
      Note: response.note,
      PetAge: response.petAge,
      PetName: response.petName,
      Type: response.type,
    },
    success: true,
  } : null;

  if (petTagResponse?.success) {
    yield put(searchPetTagFound(petTagResponse?.Data));
  } else {
    const menssage = petTagResponse?.Message || 'Unexpected Error';
    yield put(searchPetTagFailed(menssage));
  }
}

export function* contactPetFamily(dispatch, { payload }) {
  const { lostPetTag, message, phoneNumber, finderName } = payload;

  const body = {
    finderName,
    message,
    petTag: lostPetTag,
    phone: phoneNumber,
  };

  const response = yield call(
    postAnonymous,
    dispatch,
    'customer/notifications/found-pet',
    body,
  );

  if (response.success) {
    yield put(sendMessageSucceed());
  } else {
    yield put(sendMessageFailed());
  }
}
